export const PRIORITIES = [
  { key: "NONE", value: "None" },
  { key: "LOW", value: "Low" },
  { key: "MEDIUM", value: "Medium" },
  { key: "HIGH", value: "High" },
];

export const IDENTITY_TYPE_DATA = [
  { key: "NRIC", value: "NRIC" },
  { key: "Passport", value: "Passport" },
  { key: "FIN", value: "FIN" },
];

export const INVESTMENT_SOURCE_TYPE_DATA = [
  { key: "CASH", value: "Cash" },
  { key: "CPF", value: "CPF" },
  { key: "SRS", value: "SRS" },
];

//Maximum 1000 characters
export const MAX_LENGTH_TEXTAREA = 1000;
